<sc-modal-dialog class="sc-contact-info-modal" id="contactInfoModal" [scModalDialogConfig]="contactInfoModalOptions" (onClose)="closeModal()">
  <header>
    <sc-title type="h2" color="primary-brand" content="Datos de contacto"></sc-title>
  </header>
  <section class="sc-contact-info-modal__main">
    @if (modalScreen==='mainScreen') {
      <div>
        <div class="row">
          @for (contact of contactsTop; track contact) {
            <div class="col-md-4">
              <div class="sc-contact-info-modal__info-box">
                <div class="sc-contact-info-modal__info-box-title">{{ contact.label }}</div>
                <div class="sc-contact-info-modal__info-box-body">
                  <p>
                    @if (contact.businessName) {
                      <span>{{ contact.businessName }}</span>
                    }
                    @if (!contact.businessName) {
                      <span>{{ (contact.firstName || '') + ' ' +
                      (contact.lastName || '') }}</span>
                    }
                  </p>
                  @if (contact.email) {
                    <p class="sc-contact-info-modal__info-box-body-email">
                      <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                    </p>
                  }
                  @if (contact.phoneNumber) {
                    <p>{{ (contact.internalNumber) ? contact.phoneNumber + ' int '
                    + contact.internalNumber : contact.phoneNumber }}</p>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <hr>
          <div class="row">
            <div class="col-md-6" [ngClass]="{ 'col-md-12': !siniestro.contact }">
              <div class="sc-contact-info-modal__info-box">
                <div class="sc-contact-info-modal__info-box-title">
                  Contacto
                </div>
                @if (siniestro && siniestro.contact) {
                  <div class="sc-contact-info-modal__info-box-body">
                    @if (siniestro.contact.name) {
                      <p>{{ siniestro.contact.name }}</p>
                    }
                    @if (siniestro.contact.email) {
                      <p class="sc-contact-info-modal__info-box-body-email">{{
                      siniestro.contact.email }}</p>
                    }
                    @if (siniestro.contact.phoneNumber) {
                      <p>{{ siniestro.contact.phoneNumber }}</p>
                    }
                  </div>
                }
                @if (siniestro && !siniestro.contact) {
                  <div class="sc-contact-info-modal__info-box-body">
                    <sc-button type="secondary" size="medium-fluid" (onClick)="changeScreen('contactEditScreen')">Agregar
                    datos de contacto</sc-button>
                  </div>
                }
              </div>
            </div>
            @if (siniestro && siniestro.contact) {
              <div class="col-md-6">
                <div class="sc-contact-info-modal__actions">
                  <sc-button type="secondary" size="small-fluid" (onClick)="changeScreen('contactEditScreen')">Editar
                  datos</sc-button>
                </div>
              </div>
            }
          </div>
          <hr>
            <div class="row">
              @for (contact of contactsBottom; track contact) {
                <div class="col-md-4">
                  <div class="sc-contact-info-modal__info-box">
                    <div class="sc-contact-info-modal__info-box-title">{{ contact.label }}</div>
                    <div class="sc-contact-info-modal__info-box-body">
                      <p>
                        @if (contact.businessName) {
                          <span>{{ contact.businessName }}</span>
                        }
                        @if (!contact.businessName) {
                          <span>{{ (contact.firstName || '') + ' ' + (contact.lastName || '') }}</span>
                        }
                      </p>
                      <p class="contact.lawFirm">{{ contact.lawFirm }}</p>
                      @if (contact.email) {
                        <p class="sc-contact-info-modal__info-box-body-email">
                          <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                        </p>
                      }
                      @if (contact.phoneNumber) {
                        <p>{{ (contact.internalNumber) ? contact.phoneNumber + ' int '
                        + contact.internalNumber : contact.phoneNumber }}</p>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (modalScreen==='contactEditScreen') {
          <div>
            @if (errorMessage) {
              <div class="sc-contact-info-modal__main__form-error mb-1">
                <sc-icon icon="icon-alert-elipse-copy"></sc-icon>
                <span class="sc-contact-info-modal__main__form-error-message">{{ errorMessage }}</span>
              </div>
            }
            <form [formGroup]="contactEditForm" novalidate>
              <div class="form-group mb-1">
                <sc-input-2 label="Nombre" size="large" formControlName="name" [errorMessages]="nameCustomMessage"></sc-input-2>
              </div>
              <div class="form-group mb-1">
                <sc-input-2 label="Teléfono" type="text" size="large" formControlName="phoneNumber"
                [errorMessages]="phoneNumberCustomMessage"></sc-input-2>
              </div>
              <div class="form-group mb-2">
                <sc-input-2 label="Email" type="email" size="large" formControlName="email"
                [errorMessages]="emailCustomMessage"></sc-input-2>
              </div>
            </form>
          </div>
        }
      </section>
      @if (modalScreen==='contactEditScreen') {
        <footer class="sc-contact-info-modal__footer">
          <div class="row">
            <div class="col-sm-6">
              <sc-button type="secondary" size="large" (onClick)="cancelContactEdition()" [disabled]="modalLoading">Cancelar</sc-button>
            </div>
            <div class="col-sm-6">
              <sc-button type="primary" size="large" (onClick)="updateContactInfo()" [loading]="modalLoading" [disabled]="contactEditForm.invalid">Guardar</sc-button>
            </div>
          </div>
        </footer>
      }
    </sc-modal-dialog>
